import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomFormsModule } from 'ng2-validation';

import { GiftcardHelpModalComponent } from '../../../payments/giftcards/giftcard-help-modal/giftcard-help-modal.component';
import { PrintersHelpModalComponent } from '../../../printing/printers/printers-help-modal/printers-help-modal.component';
import { ClosingReportHelpModalComponent } from '../../../reports/closing-report/closing-report-help-modal/closing-report-help-modal.component';
import { OutsideClickModule } from '../../click/ls-outside-click.module';
import { CustomValidatorModule } from '../../custom-validator/custom-validator.module';
import { DynamicTranslationModule } from '../../dynamic-translation/dynamic-translation.module';

import { CheckBlockModule } from '../check-block/check-block.module';
import { LsCheckboxModule } from '../checkbox/ls-checkbox/ls-checkbox.module';
import { ComponentsModule } from '../components.module';
import { LsSingleSelectModule } from '../select/single/ls-single-select/ls-single-select.module';
import { ToggleButtonModule } from '../toggle-button/toggle-button.module';

import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { DashboardSettingsModalComponent } from './dashboard-goal-settings-modal/dashboard-goal-settings-modal.component';
import { DeleteModalComponent } from './delete-modal/delete-modal.component';
import { DownloadExceptionModalComponent } from './download-exception-modal/download-exception-modal.component';
import { FdmBlackBoxModalComponent } from './fdm-black-box-modal/fdm-black-box-modal.component';
import { GiftcardSettingsComponent } from './giftcard-settings/giftcard-settings.component';
import { MessageModalComponent } from './message-modal/message-modal.component';
import { ModalComponent } from './modal.component';
import { ShiftSettingModalComponent } from './shift-setting/shift-setting-modal.component';
import { TimezoneModalComponent } from './timezone-modal/timezone-modal.component';
import { ImportModalComponent } from './import-modal/import-modal.component';
import { TableModule } from '../table/table.module';

@NgModule({
  imports: [
    CheckBlockModule,
    CommonModule,
    ComponentsModule,
    CustomFormsModule,
    CustomValidatorModule,
    DynamicTranslationModule,
    FormsModule,
    LsCheckboxModule,
    LsSingleSelectModule,
    OutsideClickModule,
    ReactiveFormsModule,
    ToggleButtonModule,
    TableModule
  ],
  declarations: [
    ClosingReportHelpModalComponent,
    ConfirmModalComponent,
    DashboardSettingsModalComponent,
    DeleteModalComponent,
    DownloadExceptionModalComponent,
    FdmBlackBoxModalComponent,
    GiftcardHelpModalComponent,
    GiftcardSettingsComponent,
    MessageModalComponent,
    ModalComponent,
    PrintersHelpModalComponent,
    ShiftSettingModalComponent,
    TimezoneModalComponent,
    ImportModalComponent
  ],
  exports: [ModalComponent]
})
export class ModalModule {}
